import React, { useState, useRef, useEffect } from "react";
import MTable from "../../Components/MTable/MTable";
import { InputSwitch } from "primereact/inputswitch";
import Overlay from "../../Components/Overlay/Overlay";
import { handlerFormError, uuid } from "../../Utils/Utils";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAllApprovals } from "../../Services/ApprovalService";

let processingId = -1;

const ApprovalPage = () => {
  let { userInfo } = useSelector((state) => state.auth);
  const mTable = useRef();

  const [state, setState] = useState({
    processing: false,
  });

  const columns = [
    {
      id: uuid(),
      title: "Process Name",
      field: "process",
      sortable: true,
    },
    {
      id: uuid(),
      title: "Action Type",
      field: "is_creation_approved",
      render: (item) => {
        if (!item.is_creation_approved)
          return (
            <span className="badge badge-success" style={{ padding: "7px" }}>
              Create Product Data
            </span>
          );
        else
          return (
            <span className="badge badge-info" style={{ padding: "7px" }}>
              Modify Product Data
            </span>
          );
      },
    },
    {
      id: uuid(),
      title: "Request Date",
      field: "approval_request_date",
      sortable: true,
      render: (item) => {
        return new Date(item.approval_request_date).toLocaleString();
      },
    },
    {
      id: uuid(),
      title: "Status",
      field: "incident_status",
      sortable: true,
      render: (item) => {
        let badge_type = "";
        if (item.incident_status == "ONPROGRESS") badge_type = "primary";
        else if (item.incident_status == "REJECTED") badge_type = "danger";
        else if (item.incident_status == "COMPLETED") badge_type = "success";
        else if (item.incident_status == "ONREVISED") badge_type = "warning";
        else badge_type = "dark";
        return (
          <span
            className={`badge badge-${badge_type}`}
            style={{ padding: "0.4rem" }}
          >
            {item.incident_status || "NOT SUBMITTED"}
          </span>
        );
      },
    },
  ];

  if (
    userInfo?.access?.master_product?.can_view &&
    userInfo?.access?.master_product?.can_update
  ) {
    columns.push({
      id: uuid(),
      title: "Action",
      render: (item) => {
        let url = "";

        if (item.type == "detail") {
          url = `/product-detail-form/${item.country_code}/${item.item_code}`;
        } else if (item.type == "master") {
          url = `/product/edit/${item.item_code}`;
        }
        return (
          <NavLink to={url}>
            <span style={{ color: "black" }}>
              <i className="fa fa-eye" />
              &nbsp;View
            </span>
          </NavLink>
        );
      },
    });
  }

  const propsTable = {
    columns,
    getData: (params) =>
      getAllApprovals({
        ...params,
        filterAnd: `next_step_nik:${userInfo?.nik}`,
      }),
    enableFilter: true,
    orders: "incident_id:desc",
  };

  const startProcessing = () => {
    processingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  };

  const stopProcessing = () => {
    clearTimeout(processingId);
    setState({ ...state, processing: false });
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h4
                style={{
                  marginTop: "0.5rem",
                  marginLeft: "0.2rem",
                  fontWeight: "400",
                }}
              >
                Approvals List
              </h4>
              <h6
                style={{
                  marginLeft: "0.2rem",
                  fontWeight: "200",
                  letterSpacing: "1.2px",
                }}
              >
                {"List of documents needing approval"}
              </h6>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <NavLink to="/home">Home</NavLink>
                </li>
                <li className="breadcrumb-item active">Approvals</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <Overlay display={state.processing} />

                <div className="card-body">
                  <MTable ref={mTable} {...propsTable} showIndex={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApprovalPage;
